import { useDispatch } from "react-redux";

import { DIALOG } from "../enum/dialogEnum";

import {
  setupDialog,
  openDialog,
  closeDialog,
  clearDialog,
} from "redux-store/static/redux/dialog";

const useDialog = (key: DIALOG) => {
  const dispatch = useDispatch();

  const setup = () => {
    dispatch(setupDialog({ key }));
  };

  const open = (payload?: any) => {
    dispatch(openDialog({ key, payload }));
  };

  // Chỉ đóng modal giữ lại payload
  const close = () => {
    dispatch(closeDialog({ key }));
  };

  // Đóng và xóa payload
  const clear = () => {
    dispatch(clearDialog({ key }));
  };

  return { setup, open, close, clear };
};

export default useDialog;
